import axios from "axios";

import type { VenueSearchRes } from "@/types/common/search/venueSearch";

/* 物件と仕事を検索する（依頼者側のみ対応） */
export default class VenueAndTaskAndUser {
  private readonly _baseUrl: string;
  private readonly _searchQueryPrefix: string;
  private readonly _venueSearch: string;

  constructor(private readonly _user: string) {
    this._baseUrl = `${process.env.APP_API_PATH}/${this._user}`;
    this._searchQueryPrefix = "q=";
    this._venueSearch = `${this._baseUrl}/venue-search?detail=1&${this._searchQueryPrefix}`;
  }

  /* キーワード検索 */
  async keywordSearch(word: string, token: any, filterList: any) {
    try {
      const res = await axios.get(
        `${this._venueSearch}${word}${
          filterList.tab === "suggestion" ? "&suggestions=1" : ""
        }`,
        token
      );
      return this._procKeywordSearchRes(res.data);
    } catch (e) {
      console.log(e);
    }
  }
  /* キーワード検索のレスポンスを加工 */
  _procKeywordSearchRes(res: VenueSearchRes) {
    //仕事名をユニーク化&ソート
    const categories = res.categories
      .filter(
        (element, index, self) =>
          self.findIndex((e) => e.name === element.name) === index
      )
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((category) => {
        return {
          id: category.id,
          name: category.name,
          task: true
        };
      });

    // クルー名をユニーク化&ソート
    const crews = res.crews
      .filter(
        (element, index, self) =>
          self.findIndex((e) => e.name === element.name) === index
      )
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((crew) => {
        return {
          id: crew.id,
          name: crew.name,
          task: false,
          isUser: true
        };
      });

    return [...res.venues, ...categories, ...crews] as {
      id: number;
      name: string;
      task?: boolean;
      isUser?: boolean;
    }[];
  }
}
